"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kpiOptionsGrouped = exports.kpiOptions = exports.getComparatorMessageDescriptor = exports.negateComparator = void 0;
var safeToFixed = function (num, fractionDigits) {
    if (!num)
        return '';
    return num.toFixed(fractionDigits);
};
var negateComparator = function (comparator) {
    switch (comparator) {
        case 'lt':
            return 'gt';
        case 'gt':
            return 'lt';
    }
};
exports.negateComparator = negateComparator;
var getComparatorMessageDescriptor = function (comparator) {
    switch (comparator) {
        case 'lt':
            return {
                id: 'kpiSelect.less_than',
                defaultMessage: 'less than',
            };
        case 'gt':
            return {
                id: 'kpiSelect.greater_than',
                defaultMessage: 'greater than',
            };
    }
};
exports.getComparatorMessageDescriptor = getComparatorMessageDescriptor;
var safeToPercent = function (num) {
    if (!num)
        return '';
    return "".concat((num * 100).toFixed(2), "%");
};
exports.kpiOptions = [
    {
        id: 'averageSquaredError',
        label: 'kpi.averageSquaredError',
        min: 0,
        max: Infinity,
        comparator: 'lt',
        group: 2,
        health: [
            [0.1, 4],
            [0.2, 3],
            [0.3, 2],
            [0.4, 1],
            [1, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'areaUnderTheCurve',
        label: 'kpi.areaUnderTheCurve',
        min: 0.5,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'truePositiveRate',
        label: 'kpi.truePositiveRate',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToPercent(kpiValue); },
    },
    {
        id: 'trueNegativeRate',
        label: 'kpi.trueNegativeRate',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToPercent(kpiValue); },
    },
    {
        id: 'falsePositiveRate',
        label: 'kpi.falsePositiveRate',
        min: 0,
        max: 1,
        comparator: 'lt',
        group: 2,
        health: [
            [0.1, 4],
            [0.2, 3],
            [0.3, 2],
            [0.4, 1],
            [1, 0],
        ],
        format: function (kpiValue) { return safeToPercent(kpiValue); },
    },
    {
        id: 'falseNegativeRate',
        label: 'kpi.falseNegativeRate',
        min: 0,
        max: 1,
        comparator: 'lt',
        group: 2,
        health: [
            [0.1, 4],
            [0.2, 3],
            [0.3, 2],
            [0.4, 1],
            [1, 0],
        ],
        format: function (kpiValue) { return safeToPercent(kpiValue); },
    },
    {
        id: 'sensitivity',
        label: 'kpi.sensitivity',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'specificity',
        label: 'kpi.specificity',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'accuracy',
        label: 'kpi.accuracy',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToPercent(kpiValue); },
    },
    {
        id: 'precision',
        label: 'kpi.precision',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'negativePredictiveValue',
        label: 'kpi.negativePredictiveValue',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'misclassificationRate',
        label: 'kpi.misclassificationRate',
        min: 0,
        max: 1,
        comparator: 'lt',
        group: 2,
        health: [
            [0.1, 4],
            [0.2, 3],
            [0.3, 2],
            [0.4, 1],
            [1, 0],
        ],
        format: function (kpiValue) { return safeToPercent(kpiValue); },
    },
    {
        id: 'cumulativeCapturedResponseTop10',
        label: 'kpi.cumulativeCapturedResponseTop10',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 1,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'cumulativeCapturedResponseTop25',
        label: 'kpi.cumulativeCapturedResponseTop25',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 1,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'cumulativeLiftTop10',
        label: 'kpi.cumulativeLiftTop10',
        min: 1,
        max: 100,
        comparator: 'gt',
        group: 1,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'cumulativeLiftTop25',
        label: 'kpi.cumulativeLiftTop25',
        min: 1,
        max: 100,
        comparator: 'gt',
        group: 1,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'cumulativeResponseTop10',
        label: 'kpi.cumulativeResponseTop10',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 1,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'cumulativeResponseTop25',
        label: 'kpi.cumulativeResponseTop25',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 1,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'fScore',
        label: 'kpi.fScore',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'informedness',
        label: 'kpi.informedness',
        min: -1,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'markedness',
        label: 'kpi.markedness',
        min: -1,
        max: 1,
        comparator: 'gt',
        group: 0,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'rootAverageSquaredError',
        label: 'kpi.rootAverageSquaredError',
        min: 0,
        max: Infinity,
        comparator: 'lt',
        group: 2,
        health: [
            [0.1, 4],
            [0.2, 3],
            [0.3, 2],
            [0.4, 1],
            [1, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'maximumAbsoluteError',
        label: 'kpi.maximumAbsoluteError',
        min: 0,
        max: Infinity,
        comparator: 'lt',
        group: 2,
        health: [
            [0.1, 4],
            [0.2, 3],
            [0.3, 2],
            [0.4, 1],
            [1, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
    {
        id: 'giniCoefficient',
        label: 'kpi.giniCoefficient',
        min: 0,
        max: 1,
        comparator: 'gt',
        group: 2,
        health: [
            [0.9, 4],
            [0.8, 3],
            [0.7, 2],
            [0.6, 1],
            [0, 0],
        ],
        format: function (kpiValue) { return safeToFixed(kpiValue, 3); },
    },
];
exports.kpiOptionsGrouped = exports.kpiOptions.reduce(function (obj, option) {
    obj[option.id] = option; // eslint-disable-line
    return obj;
}, {});
//# sourceMappingURL=keyPerformanceIndicators.js.map